import { HERO_BADGES, PRIMARY_HEADLINE, OFFER_CLARIFIER, HERO_CLOSING_TAGLINE } from "../constants/content";
import { useCheckoutUrl } from "../lib/useCheckoutUrl";
import { trackInitiateCheckout } from "../lib/trackConversion";

export const Hero = () => {
  const checkoutUrl = useCheckoutUrl();
  return (
    <section
      id="hero"
      data-testid="dual-angle-hero-section"
      className="relative bg-[#F5F5F5] pt-16 md:pt-24 pb-6 md:pb-10 overflow-hidden"
    >
      <div className="max-w-3xl mx-auto px-6 text-center mb-4 md:mb-6">
        <h1
          data-testid="hero-headline"
          className="font-sans font-bold text-4xl sm:text-5xl md:text-6xl tracking-tight leading-[1.05] text-[#111111]"
        >
          {PRIMARY_HEADLINE}
        </h1>
        <p
          data-testid="hero-offer-clarifier"
          className="mt-4 text-base sm:text-lg font-semibold text-urgency leading-snug max-w-xl mx-auto"
        >
          {OFFER_CLARIFIER}
        </p>
        <p
          data-testid="hero-closing-tagline"
          className="mt-3 text-sm sm:text-base italic text-[#111111]/60 max-w-xl mx-auto"
        >
          {HERO_CLOSING_TAGLINE}
        </p>
      </div>

      <div className="max-w-5xl mx-auto px-0 md:px-12">
        <img
          src="/images/hero-dual-mentor.webp"
          srcSet="/images/hero-dual-mentor-mobile.webp 800w, /images/hero-dual-mentor.webp 1600w"
          sizes="(max-width: 767px) 100vw, 1024px"
          alt="Learn Dentistry From Both Angles: Function (C&B Masterclass) and Aesthetics (Porcelain Veneer Masterclass) with Prof. Dr. Moez Khakiani"
          data-testid="dual-angle-hero-image"
          className="w-full h-auto"
          width="1600"
          height="900"
          loading="eager"
          fetchPriority="high"
        />
      </div>
      <div data-testid="hero-image-badges" className="flex flex-wrap justify-center gap-3 mt-6 md:mt-8 px-6">
        {HERO_BADGES.map((badge) => (
          <span
            key={badge}
            data-testid={`hero-badge-${badge.toLowerCase().replace(/[^a-z]+/g, "-")}`}
            className="inline-flex items-center rounded-full border border-urgency/40 bg-urgency/10 px-4 py-1.5 text-[11px] md:text-xs uppercase tracking-[0.18em] font-medium text-urgency"
          >
            {badge}
          </span>
        ))}
      </div>
      <div className="flex justify-center mt-5 md:mt-6 px-6">
        <a
          href={checkoutUrl}
          target="_blank"
          rel="noopener noreferrer"
          onClick={trackInitiateCheckout}
          data-testid="hero-image-cta-button"
          className="rounded-full bg-[#111111] text-white font-semibold px-8 py-3.5 text-sm md:text-base tracking-wide hover:bg-[#2a2a2a] transition-colors duration-200 shadow-[0_15px_30px_-10px_rgba(0,0,0,0.3)]"
        >
          Buy Now &mdash; Get Both Masterclasses
        </a>
      </div>
    </section>
  );
};
